export enum ScreenNames {
  KidsProfileCreationName = "kids_profile_creation_name",
  KidsProfileCreationParentPin = "kids_profile_creation_parent_pin",
  ManageTracking = "manage_tracking",
  ParentPinInput = "parent_pin_input",
  ProfileSelector = "profile_selector",
  ResetParentPin = "reset_parent_pin",
  ProfileSettings = "profile_settings",
  UpdateProfile = "update_profile",
  ParentPinCreation = "parent_pin_creation",
  ReligiousEdProfileTypeSelection = "religious_ed_profile_type_selection",
  ReligiousEdProfileSelection = "religious_ed_profile_selection",
  ReligiousEdNameInput = "religious_ed_name_input",
  ReligiousEdCompleteProfileInfo = "religious_ed_complete_profile_info",
  ReligiousEdProfileConfirmation = "religious_ed_profile_confirmation",
  ReligiousEdCreationParentPin = "religious_ed_creation_parent_pin",
}
